import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonPrint from '@components/Print/ButtonPrint';
import Loading from '@components/Shared/Loader/Loading';
import { useEffect } from 'react';
import { TreeSelect } from 'antd';
import {
  getPurchaseQuotationById,
  cleanUpPurchaseQuotationById,
  updatePurchaseQuotation
} from '@store/purchases/PurchaseQuotation/purchaseQuotationSlice';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import PurchaseQuotationLines from './PurchaseQuotationLines';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { Can } from '@Permisstions/Can';

const Update = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { InventoryOptions, loading: loading3 } = useGetInventoryWithPermission();
  const { OperatingUnitOptions, loading: loading7, error: error7 } = useGetOperatingUnitWithPermission();

  const { PaymentMethodList } = useGetPaymentMethod();
  const { treeSuppliersData, SuppliersList, loading: loading2 } = useGetSuppliersList();

  // const { data, loading: loading5 } = useGetTransactionsSalesById({ id: id ?? '' });

  const { PurchaseQuotationById: data, loading: loading5 } = useAppSelector(s => s.PurchaseQuotation);

  useEffect(() => {
    if (id) {
      dispatch(getPurchaseQuotationById(id));
    }
    return () => {
      dispatch(cleanUpPurchaseQuotationById());
    };
  }, [id]);

  // console.log(data);
  //#region Formik
  const formik = useFormik({
    initialValues: {
      id: data ? data.id : '',
      // no: data ? data.no : '',
      code: data ? data.code : '',
      // name: data ? data.name : '',
      // name2: data ? data.name2 : '',
      // transTypeId: data ? data.transTypeId : '',
      categoryId: null,

      organizationId: data ? data.organizationId : '',
      peopleId: data ? data.peopleId : '',
      recipientname: data ? data.recipientname : '',
      billToLocationId: data ? data.billToLocationId : '',
      shipToLocationId: data ? data.shipToLocationId : '',
      referenceId: data ? data.referenceId : '',
      transactionDate: data ? data.transactionDate?.split('T')[0] : '',
      deliveryDate: data ? data.deliveryDate?.split('T')[0] : '',
      expirationDate: data ? data.expirationDate?.split('T')[0] : '',
      dueDate: data ? data.dueDate?.split('T')[0] : '',
      paymentTermsId: data ? data.paymentTermsId : '',
      description: data ? data.description : '',
      grossAmount: data ? data.grossAmount : '',
      discountRate: data ? data.discountRate : '',
      discountAmount: data ? data.discountAmount : '',
      vat: data ? data.vat : '',
      netAmount: data ? data.netAmount : '',
      isAme: true,
      ameStatus: data ? data.ameStatus : 0,
      personId: data ? data.personId : '',
      contractId: data ? data.contractId : 'e',
      paymentTerms: data ? data.paymentTerms : '',
      deliveryTerm: data ? data.deliveryTerm : '',
      inventoryId: data ? data.inventoryId : '',
      waybill: data ? data.waybill : '',
      phone: data ? data.phone : '',
      currencyCode: data ? data.currencyCode : '',
      currencyConversionRate: data ? data.currencyConversionRate : '',
      batchId: data ? data.batchId : '',
      paymentMethodId: data ? data.paymentMethodId : '',
      transactionsLinesList:
        data?.transactionsLinesList?.map(item => ({
          id: item.id,
          // transactionId: item.transactionId,
          itemId: item.itemId,
          lineNumber: item.lineNumber,
          uom: item.uom,
          description: item.description,
          price: item.price,
          qty: item.qty,
          discountRate: item.discountRate,
          discountAmount: item.discountAmount,
          vatRate: item.vatRate,
          total: item.total,
          vatAmount: item.vatAmount,
          // unitCost: item.unitCost,
          // codeCombinationId: item.codeCombinationId,
          // currencyCode: item.currencyCode,
          // currencyConversionRate: item.currencyConversionRate,
          // lotId: item.lotId,
          // headerId: item.headerId,
          // lineId: item.lineId,
          inventoryId: item.inventoryId,
          type: item.itemId === null ? 'Non_Inv' : 'Inv'
        })) || []
    },

    enableReinitialize: true,
    // validationSchema: AddQuoteInvoiceSchema(t),
    onSubmit: values => {
      const { transactionsLinesList, ...restValues } = values;

      if (values.transactionsLinesList?.length === 0) {
        SwalAlert({ text: 'أدخل أصناف' });
        formik.setSubmitting(false);

        return;
      }

      dispatch(
        updatePurchaseQuotation({
          id: values.id,
          organizationId: values.organizationId,
          peopleId: values.peopleId,
          recipientname: values.recipientname,
          billToLocationId: billToLocationId,
          shipToLocationId: shipToLocationId,
          referenceId: values.referenceId,
          transactionDate: values.transactionDate,
          deliveryDate: values.deliveryDate || null,
          expirationDate: values.expirationDate || null,
          dueDate: values.dueDate || null,
          paymentTermsId: paymentTermsId,
          description: values.description,
          // grossAmount: 0,
          // discountRate: values.discountRate || 0,
          // discountAmount: values.discountAmount || 0,
          // vat: values.vat || 0,
          // netAmount: values.netAmount || 0,
          contractId: values.contractId || null,
          // ameStatus: values.ameStatus || 0,
          // isAme: values.isAme || false,
          personId: values.personId,
          paymentTerms: values.paymentTerms,
          deliveryTerm: values.deliveryTerm,
          inventoryId: values.inventoryId || null,
          waybill: values.waybill,
          phone: values.phone,
          currencyCode: values.currencyCode,
          currencyConversionRate: values.currencyConversionRate || 0,
          batchId: values.batchId || null,
          paymentMethodId: values.paymentMethodId || null,

          transactionsLinesList: formik.values.transactionsLinesList?.map(item => ({
            id: item.id,
            transactionId: data.id,
            itemId: item.itemId,
            lineNumber: item.lineNumber,
            uom: item.uom,
            description: item.description,
            price: Number(item.price),
            qty: Number(item.qty),
            discountRate: Number(item.discountRate),
            discountAmount: Number(item.discountAmount),
            vatRate: Number(item.vatRate),
            total: Number(item.total),
            vatAmount: Number(item.vatAmount),
            // unitCost: Number(item.unitCost),
             // currencyCode: 'SAR',
            // currencyConversionRate: 0,
            // lotId: null,
            // headerId: null,
            // lineId: null,
            inventoryId: values.inventoryId || null
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion
  console.log(values.transactionsLinesList);

  const paymentTermsId = SuppliersList?.find(f => f.id === values.peopleId)?.termsId;
  const shipToLocationId = SuppliersList?.find(f => f.id === values.peopleId)?.shipToLocationId;
  const billToLocationId = SuppliersList?.find(f => f.id === values.peopleId)?.billToLocationId;

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'عروض الأسعار',
              link: '/PUR/Quotation'
            },
            {
              name: 'عرض سعـر جديد',
              link: null
            }
          ]}
          PageName=' تفاصيـل عرض السعر'
        />

        <div className='ms-auto'>
          <div className='col-5 col-md-6 text-end'>
            <ButtonPrint
              PrintTemplateTypeId='868E12B7-A5D3-41F9-AA87-45BB552B3AAB' // قوالب عرض السعر
              ReferenceId={id || ''}
            />
          </div>
        </div>
      </div>

      <Card>
        <Loading loading={loading2 || loading3 || loading5}>
          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row'>
                <div className='col-lg-3'>
                  <div className='form-group flex-nowrap mb-3'>
                    <label className='form-label'>{t('رقم العرض')}</label>

                    <div className='input-group flex-nowrap'>
                      <Form.Control
                        readOnly
                        // className="form-control fw-bold text-center"
                        className='form-control fw-bold text-center fs-5 text-theme'
                        type='text'
                        autoComplete='off'
                        onChange={formikhandleChange}
                        value={values.code || ''}
                        isInvalid={!!(touched.code && errors.code)}
                      />
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ العرض')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                      isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    <div className='text-danger'>{formik.errors.transactionDate}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ الإنتهاء')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='expirationDate'
                      onChange={formikhandleChange}
                      value={values.expirationDate || ''}
                      isInvalid={!!(touched.expirationDate && errors.expirationDate)}
                    />
                    <div className='text-danger'>{formik.errors.expirationDate}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الفرع')}</label>
                    <label className='form-label'>{t('الوحدة التشغيليـة')}</label>

                    <Select
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      onChange={(option: any) => {
                        formik.setFieldValue('inventoryId', '');
                        formik.setFieldValue('organizationId', option?.value || '');
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />

                    <div className='text-danger'>{formik.errors.organizationId}</div>
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن')}</label>

                    <Select
                      classNamePrefix='react-select'
                      // isLoading={loading4}
                      isSearchable
                      isClearable
                      options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.organizationId)}
                      value={
                        formik.values.inventoryId &&
                        InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
                      }
                      onChange={option => formik.setFieldValue('inventoryId', option?.value || null)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{formik.errors.inventoryId}</div>
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المورد')}</label>
                    <TreeSelect
                      showSearch
                      // value={value}
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      // treeDefaultExpandAll
                      value={formik.values.peopleId}
                      onChange={(option: any) => {
                        formik.setFieldValue('peopleId', option === null ? null : option);
                      }}
                      treeData={treeSuppliersData}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger'>{formik.errors.peopleId}</div>
                  </div>
                </div>
                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentMethod')}</label>
                    <Form.Select
                      className='form-select'
                      name='paymentMethodId'
                      onChange={formik.handleChange}
                      value={formik.values.paymentMethodId || ''}
                      isInvalid={!!formik.errors.paymentMethodId}
                    >
                      <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PaymentMethodList?.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.paymentMethodId}</Form.Control.Feedback>
                  </div>
                </div>

                {/* <div className="col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('مدة التوريد')}</label>
                    <Form.Control
                      className="form-control"
                      as="textarea"
                      rows={2}
                      name="deliveryTerm"
                      onChange={formik.handleChange}
                      value={values.deliveryTerm}
                      isInvalid={!!(touched.deliveryTerm && errors.deliveryTerm)}
                      // isValid={touched.deliveryTerm && !errors.deliveryTerm}
                    />
                  </div>
                </div> */}

                <div className='col-lg-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الشروط')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='paymentTerms'
                      onChange={formik.handleChange}
                      value={values.paymentTerms || ''}
                      // isInvalid={!!(touched.paymentTerms && errors.paymentTerms)}
                      // isValid={touched.paymentTerms && !errors.paymentTerms}
                    />
                  </div>
                </div>

                <div className='col-lg-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                      isInvalid={!!(touched.description && errors.description)}
                      // isValid={touched.description && !errors.description}
                    />
                  </div>
                </div>
              </div>

              <CardFooter className='px-0 py-1'>
                <div className='row'>
                  {Object.keys(data)?.length > 0 && <PurchaseQuotationLines formik={formik} />}
                  {formik.errors.transactionsLinesList?.length && (
                    <div className='text-danger'> * هناك حقول مطلوبة </div>
                  )}
                </div>
              </CardFooter>

              <div className='text-center mt-2'>
                <Can permission={'PUREditQuotation'}>
                  <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
                    {formik.isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fa fa-save fa-fw me-1'></i>
                    )}

                    {t('Save')}
                  </button>
                </Can>
                <button
                  type='button'
                  className=' btn btn-lg me-1 btn-default mb-1'
                  onClick={() => navigate('/PUR/Quotation', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </CardBody>
          </Form>
        </Loading>
      </Card>
    </div>
  );
};

export default Update;
